/**
 * i18n Configuration
 *
 * Internationalization setup using i18next and react-i18next.
 * Supports English, Simplified Chinese, and Traditional Chinese.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';
import { setI18nInstance } from '../utils/translationHelpers';

/**
 * Supported languages with their display names
 */
export const SUPPORTED_LANGUAGES = {
  en: 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
} as const;

/**
 * Language code type
 */
export type LanguageCode = keyof typeof SUPPORTED_LANGUAGES;

/**
 * Initialize i18next
 */
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-CN': { translation: zhCN },
      'zh-TW': { translation: zhTW },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback to English if translation missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Critical for React Native
    },
    compatibilityJSON: 'v3', // React Native compatibility
  })
  .then(() => {
    // Set the i18n instance for translation helpers after initialization
    setI18nInstance(i18n);
  });

export default i18n;
